import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { ApolloProvider } from '@apollo/client';
import Navigation from './src/Components/Nav/index';
import './src/Config/LangConfig.ts';
/* import 'react-native-gesture-handler'; */
import GQLClient from './src/Config/GraphqlConfig';
import * as Notifications from "expo-notifications";
import "./src/Config/LangConfig";
import FlashMessage from 'react-native-flash-message';
import { useCustomFonts } from './src/utils/fontLoader';
const client = GQLClient.getIntance()
const apolloClient = client.getClient()
const langs = ["en", "fr", "es", "ru", "pt", "it"];

Notifications.setNotificationHandler({
    handleNotification: async () => ({
        shouldShowAlert: true,
        shouldPlaySound: true,
        shouldSetBadge: false,
    }),
});

function App() {
    const { t, i18n } = useTranslation()

    const [fontsLoaded] = useCustomFonts();

    const setAppLang = async () => {
        try {
            const lang = await AsyncStorage.getItem("appLanguage");
            if (lang && langs.includes(lang)) {
                i18n.changeLanguage(lang);
            } else {
                i18n.changeLanguage("fr");
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        setAppLang();
    }, []);

    if (!fontsLoaded) {
        return null;
    }

    return (
        <>
            <ApolloProvider client={apolloClient}>
                <Navigation />
            </ApolloProvider>
            <FlashMessage position="top" />
        </>
    );
}

export default App;